import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Section5() {
  return <section className="py-20 px-6 bg-ivory-dark border-y border-gold/20" data-id="element-201">
      <div className="max-w-4xl mx-auto" data-id="element-202">
        <FadeIn data-id="element-203">
          <div className="bg-white p-8 md:p-12 rounded-lg shadow-xl border-t-4 border-gold relative overflow-hidden" data-id="element-204">
            <div className="absolute top-0 right-0 p-8 opacity-5 pointer-events-none" data-id="element-205">
              <ShieldCheck size={200} data-id="element-206" />
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-center relative z-10" data-id="element-207">
              <div className="shrink-0" data-id="element-208">
                <div className="w-24 h-24 bg-gold/10 rounded-full flex items-center justify-center" data-id="element-209">
                  <ShieldCheck size={48} className="text-gold" data-id="element-210" />
                </div>
              </div>

              <div data-id="element-211">
                <h2 className="text-3xl font-bold text-dark mb-4" data-id="element-212">
                  GARANTÍA TOTAL
                </h2>
                <p className="text-xl font-serif text-gold-dark mb-4 italic" data-id="element-213">
                  Mi compromiso contigo es simple:
                </p>
                <p className="text-dark-light leading-relaxed mb-6" data-id="element-214">
                  Lee el manual. Envía las cartas. Si en 30 días no recibes
                  ninguna respuesta de los Bureaus confirmando que recibieron tu
                  disputa, escríbeme y te devuelvo tus $16 de inmediato. Sin
                  cuestionarte. Sin pedirte que "lo intentes de nuevo". Te
                  quedas con el manual de regalo por las molestias.
                </p>
                <p className="font-bold text-dark uppercase tracking-wider text-sm" data-id="element-215">
                  El riesgo es completamente mío.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}